module.exports = __webpack_public_path__ + "img/cxample_16.ce55869c.png";